'use client'

import { faCheckDouble } from '@fortawesome/free-solid-svg-icons'
import { useTranslations } from 'next-intl'
import { useCachedModuleObjectivesSWR } from '~/app/actions/progress'
import OverviewStatusChip from '~/components/progress/OverviewStatusChip'
import { SupportedLocales } from '~/types'

export default function ModuleObjectiveProgress({
  courseId,
  moduleId,
  locale,
}: {
  courseId: string | number
  moduleId: string | number
  locale: SupportedLocales
}) {
  const t = useTranslations()
  const { data } = useCachedModuleObjectivesSWR({
    courseId,
    moduleId,
    locale,
  })

  const availableObjs = data?.availableObjs ?? 0
  const completedObjs = data?.completedObjs ?? 0

  if (availableObjs === 0) {
    return null
  }

  return (
    <OverviewStatusChip
      icon={faCheckDouble}
      kind="objective"
      completed={completedObjs}
      total={availableObjs}
      label={t('generic.nCompletedObjectives', {
        completed: completedObjs,
        available: availableObjs,
      })}
    />
  )
}
